module.exports = __webpack_public_path__ + "img/banner_new.70918617.png";